<style>
.edi-mobilebind {
	height: 100%;
	background-color: #eee;
}
.ui-content .ui-listview-inset {
	margin: 1em 0;
	-webkit-border-radius: .3125em;
	border-radius: .3125em;
}
.ui-btn {
	cursor: pointer;
	padding: .3em .8em;
	margin-right: .3em;
}
</style>

<template>
	<div class="edi-mobilebind">
		<navbar title="绑定手机号码"></navbar>
		<div class="ui-content">
			<ul class="ui-listview ui-listview-inset fieldset-1">
				<li class="ui-listview-first-item"><input type="text" v-model="mobile" placeholder="手机号"/></li>
				<li class="ui-listview-first-item" style="display: flex;border-bottom: 1px solid #ddd">
					<input type="text" name="verifyCode" v-model="verifyCode" placeholder="图形验证码" />
					<img :src="verifyCodeImg" @click="refreshVerifyCodeClick" style="height: 36px" />
				</li>
				<li class="ui-listview-last-item">
					<div class="ui-col-6"><input type="text" v-model="code" placeholder="验证码"/></div
						><div class="ui-col-4 ui-align-right"><mobile-code :type="6" :mobile="mobile" :uuid="verifyUUID" :verifyCode="verifyCode"></mobile-code></div>
				</li>
			</ul>
			<fieldset class="ui-controlgroup">
				<input type="submit" value="绑定" class="submit" @click="onSubmit"/>
			</fieldset>
		</div>
		<tips v-show="tips" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
		<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
	</div>
</template>

<script>
import MobileCode from '../components/MobileCode'
import Tips from '../components/Tips'
import TipsAuto from '../components/TipsAuto'
import NavBar from '../components/NavBar'

export default {
	data () {
		return {
			tips: false,
			tipsauto: false,
			msg: [],
			btnNum: 1,
			tipsFont: '',
			mobile: '',
			code: '',
			// patrn: /^(((13[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1}))+\d{8})$/,
			patrn: /^([0-9]{11})$/,
			codePatrn: /^\d{4}$/,
			sec: 1500,
			verifyUUID: this.$fxUtils.createUUID(),
			verifyCode: ''
		}
	},
	computed: {
		submitDisable () {
			return !this.code
		},
		verifyCodeImg () {
			return `/cldEdi/business/${this.verifyUUID}/getVerifyCode`
		}
	},
	components: {
		'mobile-code': MobileCode,
		'tips': Tips,
		'tips-auto': TipsAuto,
		'navbar': NavBar
	},
	methods: {
		refreshVerifyCodeClick () {
			this.verifyUUID = this.$fxUtils.createUUID()
		},
		tipStatus (msg) {
			this.tips = msg[0]
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		delaySkip (path) {
			var self = this
			setTimeout(() => {
				this.$router.push({path: path})
			}, self.sec)
		},
		onSubmit () {
			if (this.mobile === '') {
				this.autoTips('手机号码不能为空')
				return false
			} else if (!(this.patrn.test(this.mobile))) {
				this.autoTips('手机号码格式不正确')
				return false
			}
			if (this.code === '') {
				this.autoTips('验证码不能为空')
				return false
			} else if (!(this.codePatrn.test(this.code))) {
				this.autoTips('验证码为四位数字')
				return false
			}
			if (this.verifyCode === '') {
				this.autoTips('图形验证码不能为空')
				return false
			}
			this.$http.post('/cldEdi/business/bindingUserTelephone', {vCode: this.code, telephone: this.mobile}).then((response) => {
				if (response.body.result) {
					this.autoTips('绑定手机成功')
					this.delaySkip('/accounts')
				} else {
					this.autoTips(response.body.message)
				}
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// MobileBind.vue?3295217e